<template>
	<div id="modal-timelog-edit">
		<div class="dimmer" @click="onDimmerClick"></div>
		<div class="popup">
			
				
			<inputfield label="Opgave" v-if="false">
				<select name="" id="" v-model="globals.modal_timelog_edit.timelog.project_key">
					<option :value="key" v-for="(project,key,i) in projects" :key="'tfs23'+i">{{project.name}}</option>
				</select>
				<div class="select-arrow">▾</div>
			</inputfield>


			<inputfield label="Opgave">
				<multiselect
					:options="multiselectOptions_project"
					:value="multielectGetOption(multiselectOptions_project,'value',globals.modal_timelog_edit.timelog.project_key)"
					@select="multiselectOnSelect_selectProject($event)"
					placeholder="Vælg..." label="label" track-by="value" select-label="" selected-label="" deselect-label="" :reset-after="false"
				/>
			</inputfield>

			<br>


			<div class="grid">
				<div class="col m50">

					<inputfield label="Arbejdstype">
						<select name="" id="" v-model="globals.modal_timelog_edit.timelog.worktype">
							<option :value="worktype.value" v-for="(worktype,i) in globals.worktypes" :key="'fesfs'+i">{{worktype.title}}</option>
						</select>
						<div class="select-arrow">▾</div>
					</inputfield><br>					
					
					
					<inputfield label="Kunde" classes="disabled" v-if="false">
						<input v-if="getClient(timelog.project_key)" :value="getClient(timelog.project_key).name" type="text" disabled placeholder="Timetal">
						<input v-else :value="'?'" type="text" disabled placeholder="Timetal">
					</inputfield><br>

					<div class="checkbox">
						<input type="checkbox" v-model="timelog.billable" id="kj12b3kj">
						<label for="kj12b3kj">Fakturérbar</label>
					</div>

				</div>
				<div class="col m50">					

					<inputfield label="Timer">
						<input v-model.number="globals.modal_timelog_edit.timelog.hours" type="number" step=".25" min="0.25" max="24" placeholder="Timetal">
					</inputfield><br>					
					
					<inputfield label="Dato">
						<input type="date" v-model="globals.modal_timelog_edit.timelog.date">
					</inputfield><br>					

				</div>				
			</div>

			<inputfield label="Kommentar">
				<input type="text" placeholder="ect. kommentar" v-model="globals.modal_timelog_edit.timelog.title">
			</inputfield><br>

			<btn block color="2" @click.native="save()">Gem</btn>

			<div class="close-btn" @click="close()">X</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
import fdb from '.././firebase_config.js'
import mixins from '../mixins.js'
import Inputfield from '.././components/Inputfield'
import Multiselect from 'vue-multiselect'
//import Box from '.././components/Box'
import Btn from '.././components/Btn'
export default {
	//name: 'leftnavbar',
	mixins: [ mixins.db, mixins.generic ],
	components: { Inputfield, Btn, Multiselect },
	data() {
		return {
			app: window.globalAppData,
			globals: globals,
			//user: auth.getUser(),
			closeOnDimmerClick: true,			
		}
	}, // data
	computed: {

		timelog(){ return globals.modal_timelog_edit.timelog },

		projects(){ return this.$store.state.firebase.projects },


		multiselectOptions_project(){
			var output = []
			for( let p of this.$store.getters['projects/getAll'] ) {
				if( p.archived ) continue
				let c = this.$store.getters['clients/getOne'](p.client_key)
				if( !c ) continue
				//if( !c ) c = {name:'Ukendt kunde'}
				output.push({ value: p.key, label: c.name + ': ' + p.name, })
			}
			return output
		},
		

	},
  	methods: {

		onDimmerClick(){
			if( this.closeOnDimmerClick ) this.close()
		},

		close(){
			globals.modal_timelog_edit.active = false
		},

		
		save(){
			var key = this.timelog['.key']
			var timelog = this.timelog
			
			var patch = {
				date: timelog.date,
				hours: timelog.hours,
				project_key: timelog.project_key,
				user_key: timelog.user_key,
				worktype: timelog.worktype,
				title: timelog.title,
				billable: timelog.billable,
				date_timestamp: moment(timelog.date, 'YYYY-MM-DD').unix(),
			}
			
			fdb.ref('timelogs').child(key).update(patch)

			globals.modal_timelog_edit.active = false
			globals.modal_timelog_edit.timelog = undefined
			eventBus.$emit('toast', {text:'Timelog updated'})
		},

		getClient(project_key){
			var client = {}
			var project = this.getProject(project_key)
			if( project['client_key'] && this.$store.state.firebase.clients[project['client_key']] ) {
				client = this.$store.state.firebase.clients[project['client_key']]
				client['.key'] = project['client_key']
			}
			return client
		},

		getProject(key){
			var project = {}
			if( !this.$store.state.firebase.projects ) return {}
			if( this.$store.state.firebase.projects[key] ) project = this.$store.state.firebase.projects[key]
			return project
		},

		multielectGetOption(options,key,val){
			if( !options ) return
			for( let option of options ) if( option[key] == val ) return option			
		},

		multiselectOnSelect_selectProject(item){
			globals.modal_timelog_edit.timelog.project_key = item.value			
		},
		

	}, //methods
	mounted(){
		var timelog = JSON.parse(JSON.stringify( globals.modal_timelog_edit.timelog ))
		this.$set( globals.modal_timelog_edit, 'timelog', timelog )
	},

}
</script>



// WEBPACK FOOTER //
// modal-timelog-edit.vue?6e1cdf10